

































































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
})
export default class Paging extends Vue {
  @Prop({ type: Number })
  paging!: number

  @Prop({ type: Number })
  currentpage!: number

  private pagingUsed (value: number) {
    this.$emit('pagingUsed', value)
  }
}
